import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Btn from 'components/buttons/Btn'
import Tip from 'components/Tip'
import { useRef, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Overlay from 'react-bootstrap/Overlay'
import Popover from 'react-bootstrap/Popover'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useAccount } from 'state/Account'
import { getDates, updateDates } from 'state/Orders'
import { FMT, newDate, storeRefs, useObjSelector } from 'utils'
// import { useRestaurants } from '../../state/Restaurants'

export default function DateSelector() {
	const { t }    = useTranslation()
	const dispatch = useDispatch()
	const dates    = useObjSelector(getDates)
	const LOCATION = useAccount().location_wording_singular || 'location' //in case of missing data in old states

	//right now we just update at midnight. In the near future we should use the last closing time. See ch22364
	// const lastClosingTime = useRestaurants()
	// 	.map((r, k) => `0${k}:00`) //FIXME: WE DON'T HAVE CLOSING TIMES YETTTTTTTTTTT
	// 	.reduce((time, max) => time > max? time : max) //TODO: this should actually know if the place closes past-midnight for proper "max" calculation
	// console.log(lastClosingTime)
	// const lastClosingTime = '00:00'

	const [show, setShow]    = useState(false)
	const [, storage, value] = storeRefs()

	async function doApply(date) {
		setShow(false)
		date        = typeof date == 'string'? date : null //we might receive an event here
		const start = date || value('start')
		let end     = date || value('end')
		end         = end < start? start : end //TODO: make this happen in the UI, as soon as the start fields changes
		dispatch(updateDates(start, end))
	}

	function setToday() { doApply(FMT.dateISO(newDate(null))) }

	//TODO: transforms don't work in text layers? https://github.com/FortAwesome/react-fontawesome/issues/419
	const today              = newDate(null)
	const [year, month, day] = dates.end.split('-')
	const Icon               = (parseInt(month) == (today.getMonth() + 1) && year == today.getFullYear())?
		<span className="fa-layers fa-fw">
			<FontAwesomeIcon icon={['far', 'calendar']} fixedWidth transform="grow-2"/>
			<span className="fa-layers-text fa-xs" style={{ marginTop: 2 }}>{parseInt(day)}</span>
		</span>
		:
		<FontAwesomeIcon icon={['far', 'calendar-alt']} transform="grow-2"/> //a tad bigger to accommodate numbers

	const buttonRef = useRef()
	return <>
		<Btn icon={Icon} title={t('Select dates')} ref={buttonRef} onClick={() => setShow(!show)}/>
		<Overlay target={buttonRef.current} placement="bottom" show={show} rootClose onHide={() => setShow(false)}>
			<Popover id="date-selector">
				<Popover.Title>
					<Form.Row>
						<Col>{t('Select one day, or a range')}</Col>
						<Col xs="auto"><Btn icon="times" variant="link" size="sm" onClick={() => setShow(false)}/></Col>
					</Form.Row>
				</Popover.Title>
				<Popover.Content>
					<Form.Group controlId="start">
						<Form.Row>
							<Form.Label column="xs" xs="3">{t('From:', { context: 'date' })}</Form.Label>
							<Col xs="9">
								<Form.Control type="date" ref={storage} defaultValue={dates.start}/>
							</Col>
						</Form.Row>
					</Form.Group>

					<Form.Group controlId="end">
						<Form.Row>
							<Form.Label column="xs" xs="3">{t('To:', { context: 'date' })}</Form.Label>
							<Col xs="9">
								<Form.Control type="date" ref={storage} defaultValue={dates.end}/>
								<Form.Text className="text-muted">
									{t('Based on {{LOCATION}} hours', { LOCATION })}
									<Tip.Bubble sm placement="top">
										{t('Orders are displayed based upon your store hours. If you\'re open past midnight, those orders will be included in the current day.')}
									</Tip.Bubble>
								</Form.Text>
							</Col>
						</Form.Row>
					</Form.Group>

					<Form.Group className="mb-0">
						<Form.Row>
							<Col xs="auto">
								<Btn variant="outline-info" icon="calendar-day" swap onClick={setToday}>{t('Today')}</Btn>
							</Col>
							<Col><Button block variant="success" onClick={doApply}>{t('Apply')}</Button></Col>
						</Form.Row>
					</Form.Group>
				</Popover.Content>
			</Popover>
		</Overlay>
	</>
}
